import $ from "jquery";

window.OnlineServicesParticulieren = window.OnlineServicesParticulieren || {};
(function(OnlineServicesParticulieren) {
  "use strict";

  function ShowOverlay(e, html) {
    e.preventDefault();

    $(".c-overlay__body").html(html);
    let overlayItem = $(".c-overlay");
    overlayItem.addClass("is-active");
    $("body").addClass("show-overlay");
    e.stopPropagation();
  }

  function HideOverlay(e) {
    e.preventDefault();

    $(".c-overlay").removeClass("is-active");
    $("body").removeClass("show-overlay");
  }

  OnlineServicesParticulieren.ShowOverlay = ShowOverlay;
  OnlineServicesParticulieren.HideOverlay = HideOverlay;
})(window.OnlineServicesParticulieren);

$(function() {
  $("html body").mousedown(function(e) {
    if (
      !$(".c-overlay").is(e.target) &&
      $(".c-overlay").has(e.target).length === 0
    ) {
      $(".c-overlay.is-active").removeClass("is-active");
      $("body").removeClass("show-overlay");
    }
  });
});
